import { useState, useEffect } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { VertexCreditMemoRequest } from "models/vertex-credit-memo";
import { useAuth } from "src/contexts/AuthContext";

export const useCreditMemoSendRequests = () => {
  const [requests, setRequests] = useState<VertexCreditMemoRequest[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const { fetchWithReauth } = useAuth();

  const fetchByMonth = async (yearMonth?: string) => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams();
      if (yearMonth) {
        queryParams.append("yearMonth", yearMonth);
      }
      const response = await fetchWithReauth(
        `${API_URL}/credit-memos?${queryParams.toString()}`,
        { method: "GET" }
      );
      const data = await checkResponse(response);
      setRequests(data.items);
    } catch (error) {
      console.error("Error fetching credit memo send requests:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchByMonth();
  }, []);

  return {
    requests,
    loading,
    fetchByMonth,
  };
};
